import React from "react";
import {HtmlDisplay} from "../../Components/Display";
import {ButtonLinkStyle} from "../../Components/Inputs";
import {GridCell, GridContainer, GridTable} from "../../Components/Grid";
import {Allow, policyEvents} from "../../Components/Authorize";
import {isGuidEmpty, isNullOrUndefined} from "../../Utilities/commonUtilities";
import {ORDER_TYPE} from "../Order/orderConstants";

interface LibraryCatalogItemProps {
    catalogId?: string;
    description?: string;
    details?: string;
    formats?: Record<string, any>[];
    handleAddToQueue?: (catalogFormatId: string) => void;
    handleEdit?: (catalogId: string, format?: string) => void;
    handleOrderRequest?: (catalogId: string, catalogFormatId: string) => void;
    handleViewOrder?: (orderId: string, catalogId: string) => void;
    orderId?: string;
    orderType?: number;
    title?: string;
    [key: string]: unknown;
}

export const LibraryCatalogItem = ({
                                       catalogId,
                                       description,
                                       details,
                                       formats,
                                       handleAddToQueue,
                                       handleEdit,
                                       handleOrderRequest,
                                       handleViewOrder,
                                       orderId,
                                       orderType,
                                       title,
                                   }: LibraryCatalogItemProps) => {


    const handleClickEdit = (format?: string) => handleEdit?.(catalogId ?? '', format);
    const handleClickViewOrder = () => handleViewOrder?.(orderId ?? '', catalogId ?? '');
    const handleClickOrderRequest = (catalogFormatId: string) => handleOrderRequest?.(catalogId ?? '', catalogFormatId);
    const itemDescription = description ? `${description}` : '';

    return <>
        <GridContainer className={`catalog__item`} hasMarginX>
            <GridCell>
                {
                    handleEdit &&
                    <Allow policyEvent={policyEvents.MANAGE_CATALOG}>
                        <div className={`align-right margin--topNegative`}>
                            <ButtonLinkStyle
                                label={`Edit Item`}
                                name={`btnEdit${catalogId}`}
                                onClick={()=>handleClickEdit()}
                            />
                        </div>
                    </Allow>
                }
                <h3 id={`title${catalogId}`} className={`margin--bottomNone`}>
                    {title + " "}
                </h3>

                <HtmlDisplay html={details}/>

                <HtmlDisplay html={itemDescription}/>


                {
                    handleViewOrder && !isNullOrUndefined(orderId) &&
                    <ButtonLinkStyle isCollapsed
                                     label={String(orderType) === ORDER_TYPE.SpecialOrderRequest.toString() ? `(View Special Order)` : `View Order`}
                                     name={`btnViewOrder${catalogId}`}
                                     onClick={handleClickViewOrder}/>
                }

                {
                    formats &&
                    <GridTable className="searchResults">
                        <thead>
                        <tr>
                            <th>Format</th>
                            <th>Availability</th>
                            <th className={`text-center`} colSpan={2}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            formats.map((format: Record<string, any>) => {
                                const {
                                    catalogFormatId,
                                    currentAvailability,
                                    formatName,
                                    numberOfCopiesAvailable,
                                    copies
                                } = format;
                                const suffix = `${catalogFormatId}`;
                                const key = `${title}-${catalogFormatId}`;
                                const handleClickAddToQueue = () => handleAddToQueue?.(catalogFormatId);
                                const isEmptyGuid = isGuidEmpty(catalogFormatId);
                                const isAvailable = !isEmptyGuid && copies.length !== 0 && numberOfCopiesAvailable !== 0;
                                const isSpecialOrder = !isEmptyGuid && copies.length === 0;
                                const isOrder = !isEmptyGuid && copies.length !== 0 && numberOfCopiesAvailable === 0;

                                return <tr key={key}>
                                    <td>{formatName}</td>
                                    <td>{currentAvailability}</td>
                                    <td className={`text-center`}>
                                        {
                                            isAvailable &&
                                            <span>
                                            <ButtonLinkStyle label={`Add to Queue`}
                                                             name={`btnAddQueue${suffix}`}
                                                             onClick={handleClickAddToQueue}/>
                                        </span>
                                        }
                                        {
                                            isSpecialOrder &&
                                            <span>

                                            <ButtonLinkStyle label={`Special Order Request`}
                                                             name={`btnSpecialOrderRequest${suffix}`}
                                                             onClick={() => handleClickOrderRequest(catalogFormatId)}/>
                                        </span>
                                        }
                                        {
                                            isOrder &&
                                            <span>
                                            <ButtonLinkStyle label={`Order Request`}
                                                             name={`btnOrderRequest${suffix}`}
                                                             onClick={() => handleClickOrderRequest(catalogFormatId)}/>
                                        </span>
                                        }
                                        <Allow policyEvent={policyEvents.MANAGE_CATALOG}>
                                        <span>
                                            &nbsp;| <ButtonLinkStyle label={`Edit Item`}
                                                                     name={`btnEdit${catalogId}`}
                                                                     onClick={() => handleClickEdit(catalogFormatId)}/>
                                        </span>
                                        </Allow>
                                    </td>
                                </tr>
                            })
                        }
                        </tbody>
                    </GridTable>
                }

            </GridCell>
        </GridContainer>
    </>;
};
